exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-graph,\nchart,\npie-chart,\nspline-chart,\ncolumn-chart {\n  display: block; }\n\ntrend-map > div,\nchart > div {\n  margin: 0 auto;\n  overflow-x: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/graph.component.scss
// module id = ../../../../../src/app/shared/components/graphs/graph.component.scss
// module chunks = main